/**
 *  상품 후기 문의 상태 이름
 */
export const REVIEW_STATUS_TEXT = {
  0: '작성 완료',
  1: '구매자가 삭제',
  2: '관리자가 삭제',
};
